export default __webpack_public_path__ + "static/media/DMK_Styleframes_03_cat.3fe905aa.jpg";